import PageHeader from "src/components/PageHeader";

export default function Attributes() {
  return (
    <PageHeader
      title="مدیریت ویژگی‌های محصولات"
    />
  )
}